import { initSocketManager, setSocketToken, useAuth, useSocket } from '@bb/session-manager';
import { Button } from '@rocket/ui';
import { type ReactNode, useEffect, useState } from 'react';

import { BBDialog } from './components';
import { QuotaExceededModal } from './components/subscription';

// biome-ignore lint/suspicious/noExplicitAny: resolved auth object is a dynamic session shape
type AnyData = any;

const GlobalEventManager = ({ children = null }: { children?: ReactNode }) => {
  const { auth } = useAuth() as { auth?: AnyData };

  const [showBackdrop, setShowBackdrop] = useState(false);
  const handleOpen = () => {
    setShowBackdrop(true);
  };

  const accessToken = auth?.user?.access_token;

  // Ensure socket manager is initialized with current token
  // (also handled by session hooks, but this guards early-mount timing)
  useEffect(() => {
    if (accessToken) {
      initSocketManager();
      setSocketToken(accessToken);
    }
  }, [accessToken]);

  // Subscribe to global events — listeners are registered/cleaned by the hook,
  // the underlying socket persists in the module-level singleton
  useSocket(
    '/global/event',
    {
      global_event_update: () => handleOpen(),
    },
    { enabled: !!accessToken }
  );

  return (
    <>
      <BBDialog
        isOpen={showBackdrop}
        title="Tenant Changed"
        size="sm"
        actions={
          <Button colorPalette="gray" onClick={() => window.location.reload()}>
            Reload Page
          </Button>
        }
      >
        Your tenant has changed. Please reload the page to continue.
      </BBDialog>
      <QuotaExceededModal />
      {children}
    </>
  );
};

export default GlobalEventManager;
